// frontend/src/stores/rowWalkStore.ts — the ONE seam between a list's walk (hooks/useRowWalk) and the peek it
// drives: the global PeekHost renders the peek apart from the page, so the walk that owns the open peek's record
// lends it here its next step — the peek's own flow (a review walk's last answer) moves on to the next row without
// knowing the list — and its way home — the sheet's close gives the focus to the row the walk stopped on, never the
// row it was opened from. Nothing renders from it.

import { create } from 'zustand';

interface RowWalkState {
  /** Steps the open peek to the walk's next row — false at the last row. Null when no walk drives the open peek. */
  stepNext: (() => boolean) | null;
  /** Where the focus goes home from `from` (the control the peek was opened from) when the walked peek closes: the
   *  same control in the row the walk stopped on — null to leave it where it was. */
  home: ((from: HTMLElement | null) => HTMLElement | null) | null;
}

export const useRowWalkStore = create<RowWalkState>()(() => ({ stepNext: null, home: null }));

/** Move the open peek on to the next row of the walk that drives it — false when none does (a peek opened from
 *  another page) or the record is the last row. */
export function stepPeekWalk(): boolean {
  return useRowWalkStore.getState().stepNext?.() ?? false;
}

/** The control the walked peek's close hands the focus to instead of `from` — null when no walk drives the peek or the
 *  walk never left `from`'s row. */
export function walkHome(from: HTMLElement | null): HTMLElement | null {
  return useRowWalkStore.getState().home?.(from) ?? null;
}
